import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { addBrowserMetricEvent } from '@atlaskit/react-ufo/interaction-metrics';
import { PageVisibleFields } from '../types';
import { eventDataProcessor } from './event-data-processor';
import { makeShareableGlobalConfig } from './shareable-global-config';
export var submitter = {
  debug: false,
  config: {
    gasv3: undefined,
    configChunk: null,
    useVisibleState: false,
    histogram: {},
    enableReactUFOTracker: false
  },
  configure: function configure(config) {
    this.config.gasv3 = config.endpoints.eventPipelineClient;
    this.config.enableReactUFOTracker = config.enableReactUFOTracker;
    this.config.configChunk = makeShareableGlobalConfig(config);
    if (config.events.all && config.events.all.sfxEvents) {
      this.config.useVisibleState = config.events.all.sfxEvents.activeTab === PageVisibleFields.pageVisibleState;
    }
  },
  setDebug: function setDebug(debug) {
    this.debug = debug;
  },
  queue: function queue(data) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var chunk, payload, client, attributes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.config.enableReactUFOTracker) {
              addBrowserMetricEvent(data);
            }
            if (_this.config.configChunk) {
              _context.next = 4;
              break;
            }
            // eslint-disable-next-line no-console
            _this.debug && console.warn('Submitter is not configured');
            return _context.abrupt("return", null);
          case 4:
            _context.next = 6;
            return _this.config.configChunk;
          case 6:
            chunk = _context.sent;
            _context.next = 9;
            return eventDataProcessor(chunk[data.config.type], data);
          case 9:
            payload = _context.sent;
            if (!(payload === null)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            if (!(_this.config.gasv3 !== undefined)) {
              _context.next = 18;
              break;
            }
            _context.next = 15;
            return _this.config.gasv3;
          case 15:
            client = _context.sent;
            attributes = {
              task: payload['event:key'],
              properties: payload
            };
            client && client.sendOperationalEvent({
              actionSubject: 'performance',
              attributes: attributes,
              source: 'performance',
              action: 'measured'
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};